/**
* 基础菜单 营销管理 专属商城管理
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.area_name" placeholder="商城名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.status" placeholder="有效状态" clearable>
          <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="success" @click="addflashdialog">新增</el-button>
        <el-button size="small" type="info" @click="editflashdialog">修改</el-button>
        <el-button size="small" type="success" @click="malllashdialog">发布商城</el-button>
        <el-button size="small" type="primary" @click="copyflashdialog">复制商城地址</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 80%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="area_name" label="商城名称" min-width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="120">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row.id,scope.row.status)"
              active-color="#409EFF">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="create_name" label="创建人" width="120" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="180">
        </el-table-column>
        <el-table-column align="left" label="操作" width="380">
          <template slot-scope="scope">
            <div>
              <el-button size="mini" type="warning" @click="setmalltion(scope.row.id)">设置商城分类</el-button>
              <el-button size="mini" type="primary" @click="setmallcommodity(scope.row.id)">设置商城商品</el-button>
              <el-button size="mini" type="danger" @click="setunit(scope.row.id)">设置单位</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="infoDialogVisible"
               width="32%"
               top="7vh"
               :before-close="handleClose"
               center>
      <el-form :model="flashForm" :rules="rules" ref="flashForm" label-width="155px" class="flashForm">
        <el-form-item label="商城名称" prop="area_name">
          <el-input v-model="flashForm.area_name" clearable maxlength="11"  placeholder="请输入商城名称">
          </el-input>
        </el-form-item>
        <el-form-item label="有效状态" prop="status">
          <el-select v-model="flashForm.status" placeholder="请选择有效状态" clearable>
            <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="PC端Banner图" prop="pc_banner_url" class="list_pic_url">
          <el-upload
            class="avatar-uploader"
            action="#"
            :on-remove="handleRemove"
            :show-file-list="false"
            :http-request="handleUpload"
            :before-upload="beforeUpload"
          >
            <img v-if="form.image" :src="form.image" class="avatar"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <div class="imgtext">
          图片尺寸1200px*400px，单张图片大小不得超过10M，仅支持jpg、jpeg、png格式
        </div>
        <el-form-item label="手机端Banner图" prop="phone_banner_url" class="list_pic_url">
          <el-upload
            class="avatar-uploader"
            action="#"
            :on-remove="handleRemove"
            :show-file-list="false"
            :http-request="handleUpload"
            :before-upload="beforeUpload2"
          >
            <img v-if="form2.image" :src="form2.image" class="avatar"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <div class="imgtext">
          图片宽度750px，高度不超过1000px，单张图片大小不得超过10M，仅支持jpg、jpeg、png格式
        </div>
        <el-form-item label="商城主题" prop="activity_template_id">
          <div style="display: flex;">
            <el-select v-model="flashForm.activity_template_id" filterable placeholder="请选择商城主题" clearable>
              <el-option
                v-for="item in templateList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-button size="small" type="success" style="margin-left: 5px" @click="previewImage()">预览</el-button>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="saveSort('flashForm')">确 认</el-button>
      </span>
    </el-dialog>

<!--    复制商城地址-->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="复制商城地址"
               :visible.sync="labelDialogVisible"
               width="30%"
               center>
      <div class="billing_item">
        <p class="label">PC版商城地址</p>
        <span class="desc">{{discussData.pc_v2_url}}</span>
      </div>
      <div class="billing_item">
        <p class="label">移动版商城地址</p>
        <span class="desc">{{discussData.phone_url}}</span>
      </div>
      <div class="billing_item">
        <p class="label">商城二维码</p>
        <span class="codeimage">
          <img class="el_image" fit="cover" :src="codeimg">
        </span>
      </div>
      <div style="margin-left: 120px;">右键点击二维码图片，选择“复制图像”即可复制二维码</div>
    </el-dialog>

    <el-dialog :visible.sync="imageFormVisible"
               width="30%"
               center
               class="frame">
      <el-image
        :src="imageData.preview_picture_url">
      </el-image>
    </el-dialog>
  </div>
</template>
<script>
import {
  areaList,
  areaAdd,
  areaUpdate,
  areaTemplateList,
  areaEnabl,
  areaDisable,
  areaDetail,
  areaPublish,
  areaInfo
} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import axios from "axios";
  import {getToken} from "../../api/commonMG";
  import {uploadFile} from "../../utils/util";

  export default {
    data: () => {
      var validateNum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入排序号'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      return {
        loading: false,
        infoDialogVisible: false,  // 弹窗
        labelDialogVisible: false,
        imageFormVisible: false,
        dialogTitle: '',  // 标题
        productId: '',
        formInline: {
          page: 1,
          rows: 10,
          area_name: '',
          status: '',
        },
        flashForm: {
          id: "",
          area_name: "",
          status: "",
          seq: "",
          pc_banner: "",
          pc_banner_url: "",
          phone_banner: "",
          phone_banner_url: "",
          activity_template_id: "",
          preview_picture_id: ""
        },
        labelForm: {
          id: '',
          pc_v2_url: '',
          phone_url: ''
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        // rules表单验证
        rules: {
          area_name: [{required: true, message: '请输入商城名称', trigger: 'blur'}],
          status: { required: true, message: '请选择有效状态', trigger: 'blur' },
          // seq: { required: true, validator: validateNum, trigger: 'blur' },
          // pc_banner_url: { required: true, message: '请选择PC端Banner图', trigger: 'blur' },
          // phone_banner_url: { required: true, message: '请选择手机端Banner图', trigger: 'blur' },
          activity_template_id: { required: true, message: '请选择商城主题', trigger: 'blur' }
        },
        selectTableData: [],
        statusList: [{
          name: '有效',
          value: 1
        }, {
          name: '无效',
          value: 0
        }],
        templateList: [],
        form: {
          image: ''
        },
        form2: {
          image: ''
        },
        imgUrl: '',
        imgUrl2: '',
        activity_zone_id: "",
        activity_area_id: "",
        discussData: {},
        codeimg: '',
        imageData: {
          id: '',
          preview_picture_url: ''
        },
        imageUrls: []
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    mounted() {
      this.activity_zone_id = this.$route.query.id;
      this.activity_area_id = this.$route.query.id;
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      malllashdialog() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        areaPublish(this.selectTableData[0].id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '您已成功发布商城'
              });
              this.getdata(this.formInline)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误,请稍后再试!')
          })
      },
      // 列表
      getdata(parameter) {
        this.loading = true
        areaList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 新增专属商城弹窗
      addflashdialog() {
        this.infoDialogVisible = true;
        this.dialogTitle = '新增专属商城';
        this.form.image = '';
        this.form2.image = '';
        this.imgUrl = '';
        this.imgUrl2 = '';
        this.flashForm = {
          id: "",
          area_name: "",
          status: "",
          seq: "",
          pc_banner: "",
          pc_banner_url: "",
          phone_banner: "",
          phone_banner_url: "",
          activity_template_id: "",
          preview_picture_id: ''
        };
        this.gettemplate()
      },
      previewImage() {
        const selectedTemplate = this.templateList.find(template => template.id === this.flashForm.activity_template_id);
        if (selectedTemplate) {
          this.imageData = selectedTemplate;
          this.imageFormVisible = true;
        }
      },
      //获取公司类型
      gettemplate() {
        this.loading = true
        areaTemplateList()
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.templateList = res.content;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 修改专属商城弹窗
      editflashdialog() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.productId = this.selectTableData[0].id;
        this.infoDialogVisible = true;
        this.dialogTitle = '修改专属商城';
        this.gettemplate()
        areaDetail(this.selectTableData[0].id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if(res.content) {
                this.form.image = res.content.pc_banner_url;
                this.form2.image = res.content.phone_banner_url;
                this.flashForm = res.content
              }
            }
          })
      },
      // 确认-新增专属商城
      saveSort(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            if (this.dialogTitle == '新增专属商城') {
              areaAdd(this.flashForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功新增专属商城'
                    });
                    this.infoDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误,请稍后再试!')
                })
            } else {
              this.flashForm.id = this.productId;
              this.flashForm.pc_banner = this.productId;
              this.flashForm.phone_banner = this.productId;
              areaUpdate(this.flashForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改专属商城'
                    });
                    this.infoDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false;
                  this.$message.error('网络错误,请稍后再试!')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline);
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      handleClose() {
        this.$refs["flashForm"].resetFields();
        this.infoDialogVisible = false;
      },
      // 无效有效状态
      changeStatus(id, status) {
        if (!status) {
          areaDisable(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: '已将状态设置为无效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          areaEnabl(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '已将状态设置为有效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      // 复制商城地址
      copyflashdialog() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData[0].status == 0) {
          this.$message.error('该商城已设为无效，不可复制商城地址!');
          return
        }
        areaInfo(this.selectTableData[0].id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              if (res.code == '-3') {
                this.$message.error('该商城还未发布，不可复制商城地址');
                this.labelDialogVisible = false;
                return
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            } else {
              this.discussData = res.content || '';
              this.labelDialogVisible = true
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
        axios({
          method: 'get',
          url: '/api/auth/product/activity/area/qrcode',
          params: { id: this.selectTableData[0].id },
          headers: {
            'Content-Type': 'application/json;charset:utf-8',
            tokenId: localStorage.getItem('logintoken'),
          },
          data: {},
          traditional: true,
          responseType: 'blob',
        }).then(res => {
          localStorage.setItem('verificationid',res.headers.verificationid)
          this.codeimg = window.URL.createObjectURL(res.data);
        });
      },
      // PC端Banner图
      beforeUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type == "image/png" || file.type == "image/jpg";
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isJPG) {
          this.$message.error("上传图片只能是 JPG、JPEG 或 PNG 格式!");
          return;
        }
        if (!isLt10M) {
          this.$message.error("上传图片大小不能超过 10M!");
          return;
        }
        // 调用[限制图片尺寸]函数
        this.limitFileWH(1200, 400, file)
      },
      // 限制图片尺寸
      limitFileWH(E_width, E_height, file) {
        const _this = this
        let imgWidth = ''
        let imgHight = ''
        const isSize = new Promise(function (resolve, reject) {
          const width = E_width
          const height = E_height
          const _URL = window.URL || window.webkitURL
          const img = new Image()
          img.onload = function () {
            imgWidth = img.width
            imgHight = img.height
            const valid = img.width === width && img.height === height
            valid ? resolve() : reject()
          }
          img.src = _URL.createObjectURL(file)
        }).then(() => {
          getToken().then(res => {
            if(res) {
              let result = uploadFile(res,file);
              result.then(res => {
                this.imgUrl =  res.data.content.file.fileUrl;
                this.flashForm.pc_banner = res.data.content.file.accessoryId;
                this.flashForm.pc_banner_url = res.data.content.file.fileUrl;
                //对返回的图片地址进行回显
                this.$set(this.form, "image",  res.data.content.file.fileUrl);
              })
            }
          });
          //阻止传到本地浏览器
          return false;
        }, () => {
          _this.$message.error({
            message: '上传图片的尺寸应为' + E_width + '*' + E_height + '，当前上传图片的尺寸为：' + imgWidth + '*' + imgHight,
            btn: false
          })
          return false
        })
        return isSize
      },
      // 手机端Banner图
      beforeUpload2(file) {
        const isJPG2 = file.type === "image/jpeg" || file.type == "image/png" || file.type == "image/jpg";
        const isLt10M2 = file.size / 1024 / 1024 < 10;
        if (!isJPG2) {
          this.$message.error("上传图片只能是 JPG、JPEG 或 PNG 格式!");
          return;
        }
        if (!isLt10M2) {
          this.$message.error("上传图片大小不能超过 10M!");
          return;
        }
        this.limitFileWH2(750, 1000, file)
      },
      // 限制图片尺寸
      limitFileWH2(E_width, E_height, file) {
        const _this = this
        let imgWidth = ''
        let imgHight = ''
        const isSize = new Promise(function (resolve, reject) {
          const width = E_width
          const height = E_height
          const _URL = window.URL || window.webkitURL
          const img = new Image()
          img.onload = function () {
            if (img.width !== 750 || img.height > 1000) {
              reject(false); // 阻止上传
            } else {
              resolve(true); // 允许上传
            }
            imgWidth = img.width
            imgHight = img.height
            const valid = img.width === width && img.height === height
            valid ? resolve() : reject()
          }
          img.src = _URL.createObjectURL(file)
        }).then(() => {
          getToken().then(res => {
            if (res) {
              let result = uploadFile(res, file);
              result.then(res => {
                this.imgUrl2 =  res.data.content.file.fileUrl;
                this.flashForm.phone_banner = res.data.content.file.accessoryId;
                this.flashForm.phone_banner_url = res.data.content.file.fileUrl;
                //对返回的图片地址进行回显
                this.$set(this.form2, "image",  res.data.content.file.fileUrl);
              })
            }
          });

          //阻止传到本地浏览器
          return false;
        }, () => {
          _this.$message.error({
            message: '上传图片的尺寸应为宽度' + E_width + ',' + '高度不超过' + E_height + '，当前上传图片的尺寸为：' + imgWidth + '*' + imgHight,
            btn: false
          })
          return false
        })
        return isSize
      },
      // 可以获取图片参数
      handleUpload(file) {
        console.log(file)
      },
      setmalltion(id) {
        localStorage.setItem('path', '/store/ificationGaining')
        let tag = {
          url: "/store/ificationGaining",
          menuname: "设置商城分类"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({
          path: '/store/ificationGaining',
          query: {id: id}
        })
      },
      setmallcommodity(id) {
        localStorage.setItem('path', '/store/productsGaining')
        let tag = {
          url: "/store/productsGaining",
          menuname: "设置商城商品"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({
          path: '/store/productsGaining',
          query: {id: id}
        })
      },
      setunit(id) {
        localStorage.setItem('path', '/store/unitGaining')
        let tag = {
          url: "/store/unitGaining",
          menuname: "设置单位"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({
          path: '/store/unitGaining',
          query: {id: id}
        })
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.area_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }

</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .flashForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .flashForm .el-input {
    width: 320px;
  }

  /deep/ .flashForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .flashForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .flashForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .flashForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .avatar {
    width: 318px;
    height: 120px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 318px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  .avatar-uploader {
    height: 122px;
  }

  .imgtext {
    color: red;
    font-size: 12px;
    margin-left: 152px;
    width: 308px;
    margin-bottom: 20px
  }

  .billing_item {
    display: flex;
    margin-bottom: 22px;
  }

  .desc {
    width: 320px;
    line-height: 22px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }

  .codeimage {
    width: 130px;
    height: 130px;
    padding: 10px;
    background: #999999;
    border-radius: 8px;
  }

  .el_image {
    width: 100%;
    height: 100%;
  }

  .label {
    width: 125px;
    height: 32px;
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #333333;
    line-height: 22px;
    padding: 5px 12px 5px 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .label:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }

  /deep/ .frame .el-dialog {
    box-shadow: none;
    background: none;

  }

  /deep/ .frame .el-icon-close:before {
    content: "";
  }

  /deep/ .frame .el-dialog--center .el-dialog__body {
    display: contents;
  }

  /deep/ .frame .el-image__error {
    width: 100px;
    height: 100px;
  }

</style>



// WEBPACK FOOTER //
// src/views/store/ExclusiveGaining.vue